module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.2 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/group.html"
    }
  }, [_vm._v("Group")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 margin-top 等 less 变量")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/swiper.html"
    }
  }, [_vm._v("Swiper")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复部分机子不支持 for of 遍历")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持更多 less 变量")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复按钮文字颜色变量")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-img.html"
    }
  }, [_vm._v("XImg")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持延迟执行属性 delay")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-03bf9c14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-03bf9c14"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.2-209.vue
// module id = 2008
// module chunks = 349